import {
  CCardBody,
  CCardHeader,
  CForm,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
  CButton,
  CSelect,
  CInputGroup,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";

const EditBidderDetails = () => {
  let history = useHistory();
  let { userId } = useParams();
  // eslint-disable-next-line no-unused-vars
  const [loading, setloading] = useState(false);
  const [emailId, setemailId] = useState();
  const [mobile, setMobile] = useState();
  const [alternateEmail, setalternateEmail] = useState();
  const [directorName, setdirectorName] = useState();
  const [lastName, setlastName] = useState();
  const [houseNo, sethouseNo] = useState();
  const [streetName, setstreetName] = useState();
  const [area, setarea] = useState();
  const [city, setcity] = useState();
  const [disctrict, setdisctrict] = useState();
  const [state, setstate] = useState();
  const [pincode, setpincode] = useState();
  const [contact1, setcontact1] = useState();
  const [contact2, setcontact2] = useState();
  const [contact3, setcontact3] = useState();
  const [fax, setfax] = useState();
  const [gst, setgst] = useState();
  const [companyName, setcompanyName] = useState();
  const [categoryName, setcategoryName] = useState();
  const [pan, setpan] = useState();
  const [registrationDetails, setregistrationDetails] = useState();
  const [registeredDistrict, setregisteredDistrict] = useState();
  const [companyType, setcompanyType] = useState();
  const [bankAccountType, setbankAccountType] = useState();
  const [accountNumber, setaccountNumber] = useState();
  const [bankBranch, setbankBranch] = useState();
  const [ifscCode, setifscCode] = useState();
  const [emdAmount, setemdAmount] = useState();
  const [purchaseCapacity, setpurchaseCapacity] = useState();
  const [biddingCapacity, setbiddingCapacity] = useState();

  const [directorName1, setdirectorName1] = useState();
  const [directorName2, setdirectorName2] = useState();
  const [directorName3, setdirectorName3] = useState();
  const [directorName4, setdirectorName4] = useState();
  const [directorName5, setdirectorName5] = useState();
  const [directorName6, setdirectorName6] = useState();
  const [directorName7, setdirectorName7] = useState();
  const [directorName8, setdirectorName8] = useState();
  const [items, setItems] = useState([]);
  const [viewUserDocuments, setviewUserDocuments] = useState();

  const [fileEventPanCard, setfileEventPanCard] = useState(false);
  const [selectedPanCardFile, setselectedPanCardFile] = useState();

  const [fileEventAadharCard, setfileEventAadharCard] = useState(false);
  const [selectedAadharCardFile, setselectedAadharCardFile] = useState();

  const [fileEventITR1, setfileEventITR1] = useState(false);
  const [selectedITR1File, setselectedITR1File] = useState();

  const [fileEventITR2, setfileEventITR2] = useState(false);
  const [selectedITR2File, setselectedITR2File] = useState();

  const [fileEventITR3, setfileEventITR3] = useState(false);
  const [selectedITR3File, setselectedITR3File] = useState();

  const [fileEventGST, setfileEventGST] = useState(false);
  const [selectedGSTFile, setselectedGSTFile] = useState();

  const [fileEventDFORegCer, setfileEventDFORegCer] = useState(false);
  const [selectedDFORegCerFile, setselectedDFORegCerFile] = useState();

  const [
    fileEventScanCopyOfPartnershipFirm,
    setfileEventScanCopyOfPartnershipFirm,
  ] = useState(false);
  const [
    selectedScanCopyOfPartnershipFirmFile,
    setselectedScanCopyOfPartnershipFirmFile,
  ] = useState();

  const [fileEventMOA, setfileEventMOA] = useState(false);
  const [selectedMOAFile, setselectedMOAFile] = useState();

  const [fileEventHUF, setfileEventHUF] = useState(false);
  const [selectedHUFFile, setselectedHUFFile] = useState();

  const [fileEventOtherDocument, setfileEventOtherDocument] = useState(false);
  const [selectedOtherDocumentFile, setselectedOtherDocumentFile] = useState();

  const [showList, setshowList] = useState();
  const getBidderDetails = async () => {
    setloading(true);
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `Bidder/getBidder?userId=${userId}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      //setviewBidderDetails(jsonobj);
      setshowList(true);

      console.log(jsonobj);
      setemailId(jsonobj.emailId);
      setMobile(jsonobj.mobile);
      setalternateEmail(jsonobj.alternateEmail);
      setdirectorName(jsonobj.directorName);
      setlastName(jsonobj.middleName);
      sethouseNo(jsonobj.houseNo);
      setstreetName(jsonobj.streetName);
      setarea(jsonobj.area);
      setcity(jsonobj.city);
      setdisctrict(jsonobj.disctrict);
      setstate(jsonobj.state);
      setpincode(jsonobj.pincode);
      setcontact1(jsonobj.contact1);
      setcontact2(jsonobj.contact2);
      setcontact3(jsonobj.contact3);
      setfax(jsonobj.fax);
      setgst(jsonobj.gst);
      setcompanyName(jsonobj.companyName);
      setcategoryName(jsonobj.categoryName);
      setpan(jsonobj.pan);
      setregistrationDetails(jsonobj.registrationDetails);
      setregisteredDistrict(jsonobj.registeredDistrict);
      setcompanyType(jsonobj.companyType);
      setbankAccountType(jsonobj.bankAccountType);
      setaccountNumber(jsonobj.accountNumber);
      setbankBranch(jsonobj.bankBranch);
      setifscCode(jsonobj.ifscCode);
      setemdAmount(jsonobj.emdAmount);
      setpurchaseCapacity(jsonobj.purchaseCapacity);
      setbiddingCapacity(jsonobj.biddingCapacity);
      setdirectorName1(jsonobj.directorName1);
      setdirectorName2(jsonobj.directorName2);
      setdirectorName3(jsonobj.directorName3);
      setdirectorName4(jsonobj.directorName4);
      setdirectorName5(jsonobj.directorName5);
      setdirectorName6(jsonobj.directorName6);
      setdirectorName7(jsonobj.directorName7);
      setdirectorName8(jsonobj.directorName8);

      //=====================================
    }
    setloading(false);
  };
  const PostBidderData = async (e) => {
    e.preventDefault();
    // alert(viewBidderDetails.emailId);
    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "Bidder/update",
      "POST",
      header,
      JSON.stringify({
        userId: Number(userId),
        emailId: emailId,
        alternateEmail: alternateEmail,
        gst: gst,
        directorName: directorName,
        lastName: lastName,
        houseNo: houseNo,
        streetName: streetName,
        area: area,
        city: city,
        disctrict: disctrict,
        state: state,
        pincode: pincode,
        contact1: contact1,
        contact2: contact2,
        contact3: contact3,
        fax: fax,
        companyName: companyName,
        categoryName: categoryName,
        pan: pan,
        registrationDetails: registrationDetails,
        registeredDistrict: registeredDistrict,
        companyType: companyType,
        bankAccountType: bankAccountType,
        accountNumber: accountNumber,
        bankBranch: bankBranch,
        ifscCode: ifscCode,
        emdAmount: emdAmount,
        purchaseCapacity: purchaseCapacity,
        biddingCapacity: biddingCapacity,
        directorName1: directorName1,
        directorName2: directorName2,
        directorName3: directorName3,
        directorName4: directorName4,
        directorName5: directorName5,
        directorName6: directorName6,
        directorName7: directorName7,
        directorName8: directorName8,
      })
    );
    const jsonobj = await response.json();

    if (response.status === 200) {
      if (jsonobj === -2) {
        alert("User not available");
      } else {
        setloading(false);
        SaveUserDoc(userId);
        // history.push("/bidderlist");
        alert("RECORD UPDATED SUCCESSFULLY");
      }
    }
  };

  const deleteDocument = async (filename, source) => {
    //setloadingForUpload(true);
    //const formData = new FormData();
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Accept", "application/json");

    const response = await apiCall(
      "User/DeleteDocument",
      "PUT",
      header,
      JSON.stringify({
        userid: userId,
        FileName: filename,
        Source: source,
      })
    );
    await response.json();

    if (response.status === 200) {
      let documents = viewUserDocuments;
      if (documents !== undefined && documents !== null) {
        if (source === "itr1path") {
          documents.itr1path = "";
          setviewUserDocuments(documents);
          console.log(viewUserDocuments);
        }
        if (source === "itr2path") {
          documents.itr2path = "";
          setviewUserDocuments(documents);
          console.log(viewUserDocuments);
        }
      }
    }
  };

  const SaveUserDoc = async (userId) => {
    let ePanCard = fileEventPanCard;
    let eAadharCard = fileEventAadharCard;
    let eITR1 = fileEventITR1;
    let eITR2 = fileEventITR2;
    let eITR3 = fileEventITR3;
    let eGST = fileEventGST;
    let eDFORegCer = fileEventDFORegCer;
    let eScanCopyOfPartnershipFirm = fileEventScanCopyOfPartnershipFirm;
    let eMOA = fileEventMOA;
    let eHUF = fileEventHUF;
    let eOtherDocument = fileEventOtherDocument;

    if (ePanCard === false) {
    }
    if (eAadharCard === false) {
    }
    if (eITR1 === false) {
    }
    if (eITR2 === false) {
    }
    if (eITR3 === false) {
    }
    if (eGST === false) {
    }
    if (eDFORegCer === false) {
    }

    if (ePanCard !== false) {
      setselectedPanCardFile(ePanCard.target.files[0]);
    }
    if (eAadharCard !== false) {
      setselectedAadharCardFile(eAadharCard.target.files[0]);
    }
    if (eITR1 !== false) {
      setselectedITR1File(eITR1.target.files[0]);
    }
    if (eITR2 !== false) {
      setselectedITR2File(eITR2.target.files[0]);
    }
    if (eITR3 !== false) {
      setselectedITR3File(eITR3.target.files[0]);
    }
    if (eGST !== false) {
      setselectedGSTFile(eGST.target.files[0]);
    }
    if (eDFORegCer !== false) {
      setselectedDFORegCerFile(eDFORegCer.target.files[0]);
    }
    if (eScanCopyOfPartnershipFirm !== false) {
      setselectedScanCopyOfPartnershipFirmFile(
        eScanCopyOfPartnershipFirm.target.files[0]
      );
    }

    if (eMOA !== false) {
      setselectedMOAFile(eMOA.target.files[0]);
    }

    if (eHUF !== false) {
      setselectedHUFFile(eHUF.target.files[0]);
    }

    if (eOtherDocument !== false) {
      setselectedOtherDocumentFile(eOtherDocument.target.files[0]);
    }

    const formData = new FormData();
    if (ePanCard !== false) {
      formData.append("filesePanCard", ePanCard.target.files[0]);
    }

    if (eAadharCard !== false) {
      formData.append("fileseAadharCard", eAadharCard.target.files[0]);
    }
    if (eITR1 !== false) {
      formData.append("fileseITR1", eITR1.target.files[0]);
    }
    if (eITR2 !== false) {
      formData.append("fileseeITR2", eITR2.target.files[0]);
    }
    if (eITR3 !== false) {
      formData.append("fileseITR3", eITR3.target.files[0]);
    }
    if (eGST !== false) {
      formData.append("fileseeGST", eGST.target.files[0]);
    }
    if (eDFORegCer !== false) {
      formData.append("fileseDFORegCer", eDFORegCer.target.files[0]);
    }
    if (eScanCopyOfPartnershipFirm !== false) {
      formData.append(
        "fileseScanCopyOfPartnershipFirm",
        eScanCopyOfPartnershipFirm.target.files[0]
      );
    } else {
      formData.append("fileseScanCopyOfPartnershipFirm", null);
    }

    if (eMOA !== false) {
      formData.append("fileseMOA", eMOA.target.files[0]);
    } else {
      formData.append("fileseMOA", null);
    }

    if (eHUF !== false) {
      formData.append("fileseHUF", eHUF.target.files[0]);
    } else {
      formData.append("fileseHUF", null);
    }

    if (eOtherDocument !== false) {
      formData.append("fileseOtherDocument", eOtherDocument.target.files[0]);
    } else {
      formData.append("fileseOtherDocument", null);
    }

    const header = new Headers();
    header.append("Accept", "application/json");

    await apiCall(`User/userdoc/${userId}`, "POST", header, formData);
  };

  const getTenderCatDrop = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Company_Category`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setItems(distJsonobj);
    }
    setloading(false);
  };
  const getUserDocument = async () => {
    const header = new Headers();
    setshowList(false);
    const response = await apiCall(
      `User/GetUserDocument?userid=${userId}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setviewUserDocuments(jsonobj);
    }
  };
  useEffect(() => {
    getTenderCatDrop(true);
    getBidderDetails();
    getUserDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <>
      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        <CCardHeader>
          <CRow className="pt-3">
            <CCol xl={12}>
              <h3>Update Bidder Details</h3>
            </CCol>
          </CRow>
          <hr />
          <CCardBody>
            <CForm className="was-validation" onSubmit={PostBidderData}>
              {/*<div className=" pl-5 pr-5" >*/}
              <CRow>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Email Address :
                  </CLabel>
                  <CInput value={emailId === null ? "" : emailId} disabled />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">Mobile :</CLabel>
                  <CInput value={mobile === null ? "" : mobile} disabled />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Alter Email :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.alternateEmail === null
                    //     ? " "
                    //     : viewBidderDetails.alternateEmail
                    // }
                    value={alternateEmail === null ? "" : alternateEmail}
                    onChange={(e) => setalternateEmail(e.target.value)}
                    //   id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Goods and Services :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.gst === null ? " " : viewBidderDetails.gst
                    // }

                    // id="exampleFormControlInput1"
                    value={gst === null ? "" : gst}
                    onChange={(e) => setgst(e.target.value)}
                  />
                </CCol>
                {/* </CRow>
              <CRow className="mt-3"> */}
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Propritor Name :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName === null
                    //     ? " "
                    //     : viewBidderDetails.directorName
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName === null ? "" : directorName}
                    onChange={(e) => setdirectorName(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Father Name :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.lastName === null
                    //     ? " "
                    //     : viewBidderDetails.lastName
                    // }

                    // id="exampleFormControlInput1"
                    value={lastName === null ? "" : lastName}
                    onChange={(e) => setlastName(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">House No :</CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.houseNo === null
                    //     ? " "
                    //     : viewBidderDetails.houseNo
                    // }

                    // id="exampleFormControlInput1"
                    value={houseNo === null ? "" : houseNo}
                    onChange={(e) => sethouseNo(e.target.value)}
                  />
                </CCol>
                {/* </CRow>
              <CRow className="mt-3"> */}
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Street Location :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.streetName === null
                    //     ? " "
                    //     : viewBidderDetails.streetName
                    // }

                    // id="exampleFormControlInput1"
                    value={streetName === null ? "" : streetName}
                    onChange={(e) => setstreetName(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Area Landmark :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.area === null
                    //     ? " "
                    //     : viewBidderDetails.area
                    // }

                    // id="exampleFormControlInput1"
                    value={area === null ? "" : area}
                    onChange={(e) => setarea(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Company City :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.city === null
                    //     ? " "
                    //     : viewBidderDetails.city
                    // }

                    // id="exampleFormControlInput1"
                    value={city === null ? "" : city}
                    onChange={(e) => setcity(e.target.value)}
                  />
                </CCol>
                {/* </CRow>
              <CRow className="mt-3"> */}
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    District Union :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.disctrict === null
                    //     ? " "
                    //     : viewBidderDetails.disctrict
                    // }

                    // id="exampleFormControlInput1"
                    value={disctrict === null ? "" : disctrict}
                    onChange={(e) => setdisctrict(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    State Name :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.state === null
                    //     ? " "
                    //     : viewBidderDetails.state
                    // }

                    // id="exampleFormControlInput1"
                    value={state === null ? "" : state}
                    onChange={(e) => setstate(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">Pincode : </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.pincode === null
                    //     ? " "
                    //     : viewBidderDetails.pincode
                    // }

                    // id="exampleFormControlInput1"
                    value={pincode === null ? "" : pincode}
                    onChange={(e) => setpincode(e.target.value)}
                  />
                </CCol>
                {/* </CRow>

              <CRow className="mt-3"> */}
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Contact No 1 :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.contact1 === null
                    //     ? " "
                    //     : viewBidderDetails.contact1
                    // }

                    // id="exampleFormControlInput1"
                    value={contact1 === null ? "" : contact1}
                    onChange={(e) => setcontact1(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Contact Number 2 :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.contact2 === null
                    //     ? " "
                    //     : viewBidderDetails.contact2
                    // }

                    // id="exampleFormControlInput1"
                    value={contact2 === null ? "" : contact2}
                    onChange={(e) => setcontact2(e.target.value)}
                  />
                </CCol>
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Contact No3 :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.contact3 === null
                    //     ? " "
                    //     : viewBidderDetails.contact3
                    // }

                    // id="exampleFormControlInput1"
                    value={contact3 === null ? "" : contact3}
                    onChange={(e) => setcontact3(e.target.value)}
                  />
                </CCol>
                {/* </CRow>

              <CRow className="mt-3"> */}
                <CCol xl={4} className="mt-3">
                  <CLabel htmlFor="exampleFormControlInput1">
                    Fax Number :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.fax === null ? " " : viewBidderDetails.fax
                    // }

                    // id="exampleFormControlInput1"
                    value={fax === null ? "" : fax}
                    onChange={(e) => setfax(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>
              <CRow xl={12} className="pt-3 ">
                <CCol xl={10}>
                  <h3>Company Details</h3>
                </CCol>
              </CRow>
              <hr />
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Company Name :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.companyName === null
                    //     ? " "
                    //     : viewBidderDetails.companyName
                    // }

                    // id="exampleFormControlInput1"
                    required
                    value={companyName === null ? "" : companyName}
                    onChange={(e) => setcompanyName(e.target.value)}
                    invalid={companyName === "" ? true : false}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Tender Category :
                  </CLabel>
                  {/* <CInput
                  // value={
                  //   viewBidderDetails.categoryName === null
                  //     ? " "
                  //     : viewBidderDetails.categoryName
                  // }
                  
                  // id="exampleFormControlInput1"
                  value={categoryName === null ? " " : categoryName}
                  onChange={(e) => setcategoryName(e.target.value)}
                /> */}
                  <CSelect
                    required
                    aria-label="Default select example"
                    onChange={(e) => setcategoryName(e.target.value)}
                    value={categoryName === null ? "" : categoryName}
                  >
                    <option value="">Select Tender Category</option>
                    {items.map((item, key) => (
                      <option key={key} value={item.categoryName}>
                        {item.categoryName}
                      </option>
                    ))}
                  </CSelect>
                </CCol>

                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Pan Card :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.pan === null ? " " : viewBidderDetails.pan
                    // }

                    // id="exampleFormControlInput1"
                    value={pan === null ? "" : pan}
                    onChange={(e) => setpan(e.target.value)}
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Registration Details :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.registrationDetails === null
                    //     ? " "
                    //     : viewBidderDetails.registrationDetails
                    // }

                    // id="exampleFormControlInput1"
                    value={
                      registrationDetails === null ? "" : registrationDetails
                    }
                    onChange={(e) => setregistrationDetails(e.target.value)}
                  />
                  <br />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of Forest Division Where Tenderer Registered
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.registeredDistrict === null
                    //     ? " "
                    //     : viewBidderDetails.registeredDistrict
                    // }

                    // id="exampleFormControlInput1"
                    value={
                      registeredDistrict === null ? "" : registeredDistrict
                    }
                    onChange={(e) => setregisteredDistrict(e.target.value)}
                  />
                </CCol>

                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Status of Tenderer :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.companyType === null
                    //     ? " "
                    //     : viewBidderDetails.companyType
                    // }

                    // id="exampleFormControlInput1"
                    value={companyType === null ? "" : companyType}
                    onChange={(e) => setcompanyType(e.target.value)}
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>
              <CRow xl={12} className="pt-3 ">
                <CCol xl={10}>
                  <h3>Bidder Capacity</h3>
                </CCol>
              </CRow>
              <hr />
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Tenderers Bank Details :
                  </CLabel>
                  <br />
                  <CLabel htmlFor="exampleFormControlInput2">
                    <b>{bankAccountType === null ? " " : bankAccountType}</b>
                  </CLabel>

                  {/* <CInput
                    // value={
                    //   viewBidderDetails.bankAccountType === null
                    //     ? " "
                    //     : viewBidderDetails.bankAccountType
                    // }

                    // id="exampleFormControlInput1"
                    value={bankAccountType === null ? " " : bankAccountType}
                    //onChange={(e) => setbankAccountType(e.target.value)}.
                    disabled
                  /> */}
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Accounter Name :
                  </CLabel>
                  <br />
                  <CLabel htmlFor="exampleFormControlInput2">
                    <b>{accountNumber === null ? "" : accountNumber}</b>
                  </CLabel>
                  {/* <CInput
                    // value={
                    //   viewBidderDetails.accountNumber === null
                    //     ? " "
                    //     : viewBidderDetails.accountNumber
                    // }

                    // id="exampleFormControlInput1"
                    value={accountNumber === null ? "" : accountNumber}
                    //onChange={(e) => setaccountNumber(e.target.value)}
                    disabled
                  /> */}
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Bank Branch :
                  </CLabel>
                  <br />
                  <CLabel htmlFor="exampleFormControlInput2">
                    <b>{bankBranch === null ? "" : bankBranch}</b>
                  </CLabel>
                  {/* <CInput
                    // value={
                    //   viewBidderDetails.bankBranch === null
                    //     ? " "
                    //     : viewBidderDetails.bankBranch
                    // }

                    // id="exampleFormControlInput1"
                    value={bankBranch === null ? "" : bankBranch}
                    //onChange={(e) => setbankBranch(e.target.value)}
                    disabled
                  /> */}
                </CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    IFS Code :{" "}
                  </CLabel>
                  <br />
                  <CLabel htmlFor="exampleFormControlInput2">
                    <b>{ifscCode === null ? "" : ifscCode}</b>
                  </CLabel>
                  {/* <CInput
                    // value={
                    //   viewBidderDetails.ifscCode === null
                    //     ? " "
                    //     : viewBidderDetails.ifscCode
                    // }

                    // id="exampleFormControlInput1"
                    value={ifscCode === null ? "" : ifscCode}
                    //onChange={(e) => setifscCode(e.target.value)}
                    disabled
                  /> */}
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Emd Amount :{" "}
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.emdAmount === null
                    //     ? " "
                    //     : viewBidderDetails.emdAmount
                    // }

                    // id="exampleFormControlInput1"
                    required
                    type="number"
                    value={emdAmount === null ? "" : emdAmount}
                    onChange={(e) => setemdAmount(e.target.value)}
                    invalid={emdAmount === "" ? true : false}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Capacity :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.purchaseCapacity === null
                    //     ? " "
                    //     : viewBidderDetails.purchaseCapacity
                    // }

                    // id="exampleFormControlInput1"
                    required
                    type="number"
                    value={purchaseCapacity === null ? "" : purchaseCapacity}
                    onChange={(e) => setpurchaseCapacity(e.target.value)}
                    invalid={purchaseCapacity === "" ? true : false}
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Bidding Capacity :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.biddingCapacity === null
                    //     ? " "
                    //     : viewBidderDetails.biddingCapacity
                    // }

                    // id="exampleFormControlInput1"
                    required
                    type="number"
                    value={biddingCapacity === null ? "" : biddingCapacity}
                    onChange={(e) => setbiddingCapacity(e.target.value)}
                    invalid={biddingCapacity === "" ? true : false}
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
                <CCol xl={4}></CCol>
              </CRow>
              <CRow xl={12} className="pt-3 ">
                <CCol xl={10}>
                  <h3>Company Directors</h3>
                </CCol>
              </CRow>
              <hr />
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName1 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName1
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName1 === null ? "" : directorName1}
                    onChange={(e) => setdirectorName1(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName2 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName2
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName2 === null ? "" : directorName2}
                    onChange={(e) => setdirectorName2(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName3 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName3
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName3 === null ? "" : directorName3}
                    onChange={(e) => setdirectorName3(e.target.value)}
                  />
                </CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName4 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName4
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName4 === null ? "" : directorName4}
                    onChange={(e) => setdirectorName4(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName5 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName5
                    // }

                    //id="exampleFormControlInput1"
                    value={directorName5 === null ? "" : directorName5}
                    onChange={(e) => setdirectorName5(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName6 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName6
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName6 === null ? "" : directorName6}
                    onChange={(e) => setdirectorName6(e.target.value)}
                  />
                </CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName7 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName7
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName7 === null ? "" : directorName7}
                    onChange={(e) => setdirectorName7(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Name of the Directors :
                  </CLabel>
                  <CInput
                    // value={
                    //   viewBidderDetails.directorName8 === null
                    //     ? " "
                    //     : viewBidderDetails.directorName8
                    // }

                    // id="exampleFormControlInput1"
                    value={directorName8 === null ? "" : directorName8}
                    onChange={(e) => setdirectorName8(e.target.value)}
                  />
                </CCol>
                <CCol xl={4}></CCol>
              </CRow>

              <CRow xl={12} className="pt-3 ">
                <CCol xl={10}>
                  <h3>User Documents</h3>
                </CCol>
              </CRow>
              <hr />
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    Pan Card<span style={{ color: "red" }}>*</span> :{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.pancardpath !== undefined &&
                            viewUserDocuments.pancardpath !== "" &&
                            viewUserDocuments.pancardpath !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventPanCard(e);
                            setselectedPanCardFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedPanCardFile ? (
                          selectedPanCardFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.pancardpath !== undefined &&
                  viewUserDocuments.pancardpath !== "" &&
                  viewUserDocuments.pancardpath !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.pancardpath}`}
                        rel="noreferrer"
                      >
                        View Pan Card
                      </a>{" "}
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(
                            viewUserDocuments.pancardpath,
                            "pancardpath"
                          )
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    Aadhar Card<span style={{ color: "red" }}>*</span> :{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.aadharcardpath !== undefined &&
                            viewUserDocuments.aadharcardpath !== "" &&
                            viewUserDocuments.aadharcardpath !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventAadharCard(e);
                            setselectedAadharCardFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedAadharCardFile ? (
                          selectedAadharCardFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.aadharcardpath !== undefined &&
                  viewUserDocuments.aadharcardpath !== "" &&
                  viewUserDocuments.aadharcardpath !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.aadharcardpath}`}
                        rel="noreferrer"
                      >
                        View AAdhar Card
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(
                            viewUserDocuments.aadharcardpath,
                            "aadharcardpath"
                          )
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}></CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    ITR Year-1<span style={{ color: "red" }}>*</span> :{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.itr1path !== undefined &&
                            viewUserDocuments.itr1path !== "" &&
                            viewUserDocuments.itr1path !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventITR1(e);
                            setselectedITR1File(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedITR1File ? (
                          selectedITR1File.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.itr1path !== undefined &&
                  viewUserDocuments.itr1path !== "" &&
                  viewUserDocuments.itr1path !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.itr1path}`}
                        rel="noreferrer"
                      >
                        View ITR Year-1
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(viewUserDocuments.itr1path, "itr1path")
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    ITR Year-2<span style={{ color: "red" }}>*</span> :{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.itr2path !== undefined &&
                            viewUserDocuments.itr2path !== "" &&
                            viewUserDocuments.itr2path !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventITR2(e);
                            setselectedITR2File(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedITR2File ? (
                          selectedITR2File.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.itr2path !== undefined &&
                  viewUserDocuments.itr2path !== "" &&
                  viewUserDocuments.itr2path !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.itr2path}`}
                        rel="noreferrer"
                      >
                        View
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(viewUserDocuments.itr2path, "itr2path")
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    ITR Year-3<span style={{ color: "red" }}>*</span> :{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.itr3path !== undefined &&
                            viewUserDocuments.itr3path !== "" &&
                            viewUserDocuments.itr3path !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventITR3(e);
                            setselectedITR3File(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedITR3File ? (
                          selectedITR3File.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments != null &&
                  viewUserDocuments.itr3path !== undefined &&
                  viewUserDocuments.itr3path !== "" &&
                  viewUserDocuments.itr3path !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.itr3path}`}
                        rel="noreferrer"
                      >
                        View ITR Year 3
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(viewUserDocuments.itr3path, "itr3path")
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    GSTIN Certificate<span style={{ color: "red" }}>
                      *
                    </span>:{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.gstincertificatepath !==
                              undefined &&
                            viewUserDocuments.gstincertificatepath !== "" &&
                            viewUserDocuments.gstincertificatepath !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventGST(e);
                            setselectedGSTFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedGSTFile ? (
                          selectedGSTFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.gstincertificatepath !== undefined &&
                  viewUserDocuments.gstincertificatepath !== "" &&
                  viewUserDocuments.gstincertificatepath !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.gstincertificatepath}`}
                        rel="noreferrer"
                      >
                        View GSTIN Certificate
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(
                            viewUserDocuments.gstincertificatepath,
                            "gstincertificatepath"
                          )
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    DFO Registration Certificate
                    <span style={{ color: "red" }}>*</span>:{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.dforegistrationcertificatepath !==
                              undefined &&
                            viewUserDocuments.dforegistrationcertificatepath !==
                              "" &&
                            viewUserDocuments.dforegistrationcertificatepath !==
                              null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventDFORegCer(e);
                            setselectedDFORegCerFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedDFORegCerFile ? (
                          selectedDFORegCerFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments != null &&
                  viewUserDocuments.dforegistrationcertificatepath !==
                    undefined &&
                  viewUserDocuments.dforegistrationcertificatepath !== "" &&
                  viewUserDocuments.dforegistrationcertificatepath !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.dforegistrationcertificatepath}`}
                        rel="noreferrer"
                      >
                        View DFO Registration Certificate
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(
                            viewUserDocuments.dforegistrationcertificatepath,
                            "dforegistrationcertificatepath"
                          )
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel> Scanned copy of Partnership Firm: </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.scannedcopyofpartnershipfirmpath !==
                              undefined &&
                            viewUserDocuments.scannedcopyofpartnershipfirmpath !==
                              "" &&
                            viewUserDocuments.scannedcopyofpartnershipfirmpath !==
                              null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventScanCopyOfPartnershipFirm(e);
                            setselectedScanCopyOfPartnershipFirmFile(
                              e.target.files[0]
                            );
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedScanCopyOfPartnershipFirmFile ? (
                          selectedScanCopyOfPartnershipFirmFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.scannedcopyofpartnershipfirmpath !==
                    undefined &&
                  viewUserDocuments.scannedcopyofpartnershipfirmpath !== "" &&
                  viewUserDocuments.scannedcopyofpartnershipfirmpath !==
                    null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.scannedcopyofpartnershipfirmpath}`}
                        rel="noreferrer"
                      >
                        View Partnership firm
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(
                            viewUserDocuments.scannedcopyofpartnershipfirmpath,
                            "scannedcopyofpartnershipfirmpath"
                          )
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel className="h-25">
                    {" "}
                    Scanned copy of Certificate of Company Incorporation of
                    Latest Directors of company, AOA and MOA :{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.moapath !== undefined &&
                            viewUserDocuments.moapath !== "" &&
                            viewUserDocuments.moapath !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventMOA(e);
                            setselectedMOAFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedMOAFile ? (
                          selectedMOAFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments != null &&
                  viewUserDocuments.moapath !== undefined &&
                  viewUserDocuments.moapath !== "" &&
                  viewUserDocuments.moapath !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.moapath}`}
                        rel="noreferrer"
                      >
                        View Company Incorporation Document
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(viewUserDocuments.moapath, "moapath")
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel>
                    {" "}
                    Scanned copy of list of family members in case of H.U.F.:{" "}
                  </CLabel>

                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments !== null &&
                            viewUserDocuments.hufpath !== undefined &&
                            viewUserDocuments.hufpath !== "" &&
                            viewUserDocuments.hufpath !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventHUF(e);
                            setselectedHUFFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedHUFFile ? (
                          selectedHUFFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                    </div>
                  </CInputGroup>

                  {viewUserDocuments !== undefined &&
                  viewUserDocuments !== null &&
                  viewUserDocuments.hufpath !== undefined &&
                  viewUserDocuments.hufpath !== "" &&
                  viewUserDocuments.hufpath !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.hufpath}`}
                        rel="noreferrer"
                      >
                        View HUF Family Member
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(viewUserDocuments.hufpath, "hufpath")
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
                <CCol xl={4}>
                  <CLabel className="h-25">
                    {" "}
                    Any other related document:{" "}
                  </CLabel>
                  <CInputGroup className="mb-3">
                    <div className="custom-file">
                      <input
                        name="file"
                        id="inputGroupFile01"
                        type="file"
                        className="custom-file-input"
                        onChange={(e) => {
                          if (
                            viewUserDocuments !== undefined &&
                            viewUserDocuments != null &&
                            viewUserDocuments.otherdocument !== undefined &&
                            viewUserDocuments.otherdocument !== "" &&
                            viewUserDocuments.otherdocument !== null
                          ) {
                            alert(
                              "This document is already uploaded. To upload new document delete existing one."
                            );
                            e.preventDefault();
                          } else {
                            setfileEventOtherDocument(e);
                            setselectedOtherDocumentFile(e.target.files[0]);
                          }
                        }}
                      />
                      <label
                        className="custom-file-label "
                        htmlFor="inputGroupFile01"
                      >
                        {selectedOtherDocumentFile ? (
                          selectedOtherDocumentFile.name
                        ) : (
                          <>Choose file</>
                        )}
                      </label>
                      <br />
                    </div>
                  </CInputGroup>
                  {viewUserDocuments !== undefined &&
                  viewUserDocuments != null &&
                  viewUserDocuments.otherdocument !== undefined &&
                  viewUserDocuments.otherdocument !== "" &&
                  viewUserDocuments.otherdocument !== null ? (
                    <div>
                      <a
                        className="ml-2"
                        target="_blank"
                        href={`${downloadUrl}/Documents/UserDocument/${viewUserDocuments.userId}/${viewUserDocuments.otherdocument}`}
                        rel="noreferrer"
                      >
                        View Other Document
                      </a>
                      |
                      <CButton
                        color="link"
                        size="sm"
                        shape="rounded-pill"
                        className="ml-2"
                        onClick={() =>
                          deleteDocument(
                            viewUserDocuments.otherdocument,
                            "otherdocument"
                          )
                        }
                      >
                        Delete
                      </CButton>
                    </div>
                  ) : (
                    ""
                  )}
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={2} sm={2}>
                  <CButton
                    className="mt-5"
                    color="success"
                    onClick={() => history.goBack()}
                  >
                    Go Back
                  </CButton>
                </CCol>
                <CCol xl={10} sm={10}>
                  <CButton className="mt-5" color="success" type="submit">
                    Update
                  </CButton>
                </CCol>
              </CRow>
              {/* </div> */}
            </CForm>
          </CCardBody>
        </CCardHeader>
      )}
    </>
  );
};
export default EditBidderDetails;
